// extracted by mini-css-extract-plugin
module.exports = {"head":"index_head_31M63","headItem":"index_headItem_18y0G","headIcon":"index_headIcon_39PmY","table":"index_table_1li6t","avatar":"index_avatar_18e57"};